<template>
<div class="uk-flex uk-flex-center">
    <div class="uk-card uk-card-default mt-5 py-4 my-3 px-3 uk-width-1-1">
    <ul uk-tab>
      <li><a href="#" class="uk-disabled">Accueil Rapport</a></li>
      <li><router-link :to="{path: '/admin/rapport/date'}" :class="'uk-active'">Rapport par Date</router-link></li>
      <li><router-link :to="{path: '/admin/rapport/livreurs'} " :class="'uk-active'">Rapport par Livreur</router-link></li>
      <li><router-link :to="{path: '/admin/rapport/commerciaux'}" :class="'uk-active'">Rapport par Commercial</router-link></li>
      <li><router-link :to="{path: '/admin/rapport/boutiques'}" :class="'uk-active'">Rapport par Boutique</router-link></li>
    </ul>
  </div>
</div>
</template>
<script>
export default {
  name: "tab-bar",
};
</script>